import { useEffect, useRef, useState, type FormEvent } from 'react'
import { api } from '../api'
import type { MailLinkDaten } from '../navigation'

const MIN_PASSWORT = 10

/** Ziel der Links aus Mails (Einladung, Passwort-Reset, E-Mail-Bestätigung); funktioniert ohne Anmeldung. */
export function MailLink({ link, onFertig }: { link: MailLinkDaten; onFertig: () => void }) {
  return (
    <div className="anmeldung">
      <div className="formular-rahmen">
        <img src="/favicon.svg" alt="" width={72} height={72} />
        <h1>meine Perlen</h1>
        {link.art === 'email' ? <EmailBestaetigung token={link.token} onFertig={onFertig} /> : <PasswortSetzen link={link} onFertig={onFertig} />}
      </div>
    </div>
  )
}

function PasswortSetzen({ link, onFertig }: { link: MailLinkDaten; onFertig: () => void }) {
  const [benutzername, setBenutzername] = useState<string | null>(null)
  const [passwort, setPasswort] = useState('')
  const [wiederholung, setWiederholung] = useState('')
  const [fehler, setFehler] = useState<string | null>(null)
  const [fertig, setFertig] = useState(false)
  const einladung = link.art === 'einladung'

  useEffect(() => {
    // Zeigt, fuer wen die Einladung ist, ohne sie zu verbrauchen
    if (einladung) api.einladungPruefen(link.token).then((e) => setBenutzername(e.benutzername)).catch((e) => setFehler((e as Error).message))
  }, [link.token, einladung])

  const absenden = async (e: FormEvent) => {
    e.preventDefault()
    setFehler(null)
    if (passwort.length < MIN_PASSWORT) return setFehler(`Bitte mindestens ${MIN_PASSWORT} Zeichen.`)
    if (passwort !== wiederholung) return setFehler('Die beiden Passwörter stimmen nicht überein.')
    try {
      if (einladung) await api.einladungAnnehmen(link.token, passwort)
      else await api.passwortZuruecksetzen(link.token, passwort)
      setFertig(true)
    } catch (err) {
      setFehler((err as Error).message)
    }
  }

  if (fertig)
    return (
      <>
        <p>{einladung ? 'Dein Zugang ist eingerichtet und deine E-Mail-Adresse bestätigt.' : 'Dein Passwort ist geändert. Alle bisherigen Anmeldungen sind beendet.'}</p>
        <button onClick={onFertig}>Zur Anmeldung</button>
      </>
    )

  return (
    <form onSubmit={absenden}>
      <p>
        {einladung ? (
          <>
            Willkommen{benutzername ? <>, <strong>{benutzername}</strong></> : ''}! Leg dein Passwort fest. Dein Tagebuch ist privat, niemand
            sonst kann es lesen.
          </>
        ) : (
          'Leg ein neues Passwort fest.'
        )}
      </p>
      {benutzername && <input type="text" autoComplete="username" value={benutzername} readOnly hidden />}
      <label>
        Neues Passwort (mindestens {MIN_PASSWORT} Zeichen)
        <input type="password" autoComplete="new-password" value={passwort} onChange={(e) => setPasswort(e.target.value)} autoFocus />
      </label>
      <label>
        Passwort wiederholen
        <input type="password" autoComplete="new-password" value={wiederholung} onChange={(e) => setWiederholung(e.target.value)} />
      </label>
      {fehler && <p className="fehler">{fehler}</p>}
      <button type="submit" disabled={!passwort}>
        Passwort speichern
      </button>
      <button type="button" className="link" onClick={onFertig}>
        Abbrechen
      </button>
    </form>
  )
}

function EmailBestaetigung({ token, onFertig }: { token: string; onFertig: () => void }) {
  const [ergebnis, setErgebnis] = useState<{ ok: boolean; text: string } | null>(null)
  const gesendet = useRef(false)

  useEffect(() => {
    if (gesendet.current) return // Token ist nur einmal gueltig (StrictMode ruft Effekte doppelt auf)
    gesendet.current = true
    api
      .emailBestaetigen(token)
      .then(() => setErgebnis({ ok: true, text: 'Deine E-Mail-Adresse ist bestätigt.' }))
      .catch((e) => setErgebnis({ ok: false, text: (e as Error).message }))
  }, [token])

  return (
    <>
      {ergebnis === null ? <p>E-Mail-Adresse wird bestätigt …</p> : <p className={ergebnis.ok ? undefined : 'fehler'}>{ergebnis.text}</p>}
      <button onClick={onFertig} disabled={ergebnis === null}>
        Weiter
      </button>
    </>
  )
}
